import { render, staticRenderFns } from "./EfileTab.vue?vue&type=template&id=8bc57f32"
import script from "./EfileTab.vue?vue&type=script&lang=js"
export * from "./EfileTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports